import { PAD_SCHEMES } from "@lache/input/schemes";
import { defaultTuning, type Tuning, tuningHash } from "@lache/sim";

/** Reconstruct the known default physics of a saved tape without changing live tuning. */
export function replayTuning(hash: string, current: Tuning): Tuning | null {
  if (hash === tuningHash(current)) return current;
  // Custom physics still need their own exact recording hash. A control layout alone does not
  // change tape inputs, so default recordings can use the scheme they were recorded with.
  if (tuningHash({ ...current, padScheme: defaultTuning.padScheme }) !== tuningHash(defaultTuning))
    return null;
  for (let padScheme = 0; padScheme < PAD_SCHEMES.length; padScheme++) {
    const modern = { ...defaultTuning, padScheme };
    if (hash === tuningHash(modern)) return modern;
    const preFlow = { ...modern, hurdleFlow: 0 };
    if (hash === tuningHash(preFlow)) return preFlow;
    const preLadder = { ...preFlow, ladderPerfectDuck: 0 };
    if (hash === tuningHash(preLadder)) return preLadder;
    const legacy = { ...preLadder, slidePerfectBoost: 0 };
    if (hash === tuningHash(legacy)) return legacy;
  }
  return null;
}
